module.exports = __webpack_public_path__ + "img/adv_scale.743a56ee.png";